import { render, staticRenderFns } from "./AddNode.vue?vue&type=template&id=2b039395&"
import script from "./AddNode.vue?vue&type=script&lang=js&"
export * from "./AddNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports